import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import modalUtility from '@sparta.homepage.utilities/modal-utility/dist/es6.js';
import _ from '@sparta.global.vendors/lodash';
import benchmarkUtility from '@sparta.sales.utilities/benchmark-utility/dist/es6.js';
import remoteConsole from '@sparta.homepage.utilities/remote-logging-utility/dist/es6.js';
import animationUtility from '@sparta.homepage.utilities/animation-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import '@sparta.global.utilities/sparta-events-utility/dist/es6.js';

/**
 * Gets current height of window.
 *
 * @testExample getWindowHeight()
 * @testOutput beA 'number'
 * @returns {Number} Window height.
 */
function getWindowHeight() {
  return window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
}

/**
 * Smooth scrolls to an element or position in the page.
 * Based on https://pawelgrzybek.com/page-scroll-in-vanilla-javascript/
 *
 * @testExample smoothScroll('#scrollToMe')
 * @testOutput undefined
 * @mockElement #scrollToMe
 * @param {Node|Number} destination Destination element or position to scroll to.
 * @param {Number} [duration=250] Duration of scroll animation.
 * @param {Function} [callback] Callback when scroll is finished.
 *
 * @returns {undefined}
 */
function smoothScroll(destination, duration = 250, callback) {
  const start = window.pageYOffset;
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  const windowHeight = getWindowHeight();
  const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);
  const scroll = () => {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, (now - startTime) / duration);
    window.scroll(0, Math.ceil(time * (destinationOffsetToScroll - start) + start));
    const isScrollFinished = window.pageYOffset === destinationOffsetToScroll;
    if (isScrollFinished) {
      if (callback) callback();
      return;
    }
    requestAnimationFrame(scroll);
  };
  scroll();
}

const SCROLL_OFFSET = 100;
const SCROLL_DURATION = 400;

/**
 * Scroll down one viewport height.
 *
 * @testExample scroll()
 * @testOutput undefined
 * @returns {void}
 */
function scroll() {
  const position = getWindowHeight - SCROLL_OFFSET;
  smoothScroll(position, SCROLL_DURATION);
}

var fnClicks = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': scroll
});

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"engagement-content "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"class") : stack1), depth0))
    + "\">\r\n  <div id=\"engagementBannerPartialContent\" class=\"banner-partial-container\" tabindex=\"-1\">\r\n  </div>\r\n  <a href=\"javascript:void(0);\" id=\"engagementBannerCloseBtn\" class=\"close\" role=\"button\" aria-label=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"global") : depth0)) != null ? lookupProperty(stack1,"globalJs") : stack1)) != null ? lookupProperty(stack1,"closeText") : stack1), depth0)) != null ? stack1 : "")
    + "\">×</a>\r\n</div>\r\n\r\n<div id=\"engagement-default\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"defaultContent") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":8,"column":39},"end":{"line":8,"column":64}}}))
    + "\"></div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <img src=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"icon") || (depth0 != null ? lookupProperty(depth0,"icon") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"icon","hash":{},"data":data,"loc":{"start":{"line":2,"column":12},"end":{"line":2,"column":22}}}) : helper))) != null ? stack1 : "")
    + "\" loading=\"lazy\" alt=\"\" aria-hidden=\"true\" />\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":7}}})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":4,"column":0},"end":{"line":4,"column":13}}}) : helper))) != null ? stack1 : "")
    + "\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.homepage.modules/engagement-banner-module",
  "version": "2.1.5",
  "id": "engagementBannerModule",
  "containerID": "homepageEngagementBannerModule",
  "moduleName": "homepage-engagement-banner-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "engagement-banner-module",
  "data": {
    "init": "engagementBannerModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "class",
    "type": "string",
    "values": [],
    "default": "",
    "description": "CSS class for the module."
  }, {
    "name": "fixed",
    "type": "string",
    "values": ["bottom-left", "bottom-right"],
    "default": "",
    "description": "Position of the fixed banner."
  }, {
    "name": "adContainer",
    "type": "object",
    "values": [],
    "default": "",
    "description": "Object containing string names for default and sing-off ad containers for engagement banner."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        json
      },
      "partials": {
        "banner-icon-text-link": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "banner-icon-text-link": renderTemplate
  },
  "helpers": {
    json
  },
  "dependencies": {
    "@sparta.sales.utilities/benchmark-utility": "^1.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.homepage.utilities/animation-utility": "^1.0.5",
    "@sparta.homepage.utilities/modal-utility": "^1.0.0",
    "@sparta.homepage.utilities/remote-logging-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0"
  },
  "stores": []
};

/* eslint-disable no-console */
const FN_CLICK_CLASSNAME_PREFIX = 'fn-click-';
const defaultTemplate = 'banner-icon-text-link';
const containerType = 'engagement-banner';

/**
 * engagement-banner-module
 * module_js_id: engagementBannerModuleJS
 */
class engagementBannerModuleJS extends Module {
  /**
   * @description Creates an instance of engagementBannerModuleJS
   * @method constructor
   * @param {Object} options options
   * @param {Object} context context
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.target = target;
    this.close = target.querySelector('.close');
    this.container = target.querySelector('.engagement-content');
    this.partialContainer = target.querySelector('.banner-partial-container');
    this.defaultContent = JSON.parse(document.getElementById('engagement-default').dataset.jcr);
    this.hideTopAt = 250;
    this.adContainer = this.params.adContainer.default;
    if (spaParams.siteParams.jsTimer) {
      benchmarkUtility.init(this);
    }
  }

  /**
   * @description init function
   * @method init
   *
   * @testExample init()
   * @testOutput equal undefined
   *
   * @testTrigger click mockedElements[0]
   * @testExpect mockedElements[1].classList.contains('fade-out') toEqual true
   *
   * @testTrigger scroll window
   * @testExpect mockedElements[1].classList.contains('fade-out') toEqual false
   *
   * @mockElement a.close
   * @mockElement .engagement-content
   * @mockElement .banner-partial-container
   * @mockElement #engagement-default {}
   * @mockSessionStorage
   *
   * @returns {void} none
   */
  init() {
    this.checkDismissed();
    if (!this.isDismissed()) {
      this.bindEventListeners();
      this.bindTransitionEvents();
    }
  }

  /**
   * @description binds event listeners, subscribes and binds events
   * @method bindEventListeners
   * @returns {void}
   */
  bindEventListeners() {
    this.close.addEventListener('click', this.handleActiveToggle.bind(this));
    window.addEventListener('scroll', this.handleScroll.bind(this));
    this.Events.sub(`target-${this.adContainer}`, this.loadContent.bind(this), true);
    this.Events.sub(`target-${this.adContainer}`, this.loadContent.bind(this), true);
    // attaching listner to document to detect click on mobile hamburger icon
    document.addEventListener('click', this.detectHeaderHamburgerIconClick);
  }

  /**
   * @description Call the appropriate function from fn-clicks.js when engagement link is clicked.
   * @method bindFnClicks
   * @testExample bindFnClicks()
   * @testOutput undefined
   * @testTrigger click mockedElements[0]
   * @testExpect fnClicks.scroll.called toEqual true
   *
   * @mockElement button.fn-click-scroll
   * @mockElement a.close
   * @mockElement .engagement-content
   * @mockElement .banner-partial-container
   * @mockElement #engagement-default {}
   * @spy fnClicks.scroll
   *
   * @returns {void}
   */
  bindFnClicks() {
    const fnClickLink = this.settings.target.querySelector(`[class*="${FN_CLICK_CLASSNAME_PREFIX}"]`);
    if (!fnClickLink) return;
    fnClickLink.addEventListener('click', event => {
      event.preventDefault();
      const fnNames = [...fnClickLink.classList].filter(className => className.includes(FN_CLICK_CLASSNAME_PREFIX)).map(className => className.slice(FN_CLICK_CLASSNAME_PREFIX.length)); // remove prefix

      fnNames.forEach(fnName => {
        const fnClickHandler = fnClicks[fnName];
        if (typeof fnClickHandler !== 'function') {
          throw new Error(`${fnName} does not exist in homepage/engagement-banner-module/fn-clicks.js`);
        }
        fnClickHandler(event);
      });
    });
  }

  /**
   * @description binds transitions events
   * @method bindTransitionEvents
   * @returns {void}
   */
  bindTransitionEvents() {
    ['webkitTransitionEnd', 'otransitionend', 'msTransitionEnd', 'transitionend'].forEach(event => {
      this.container.addEventListener(event, e => {
        if (e.propertyName === 'opacity' && this.container.classList.contains('fade-out')) {
          this.container.classList.add('hide');
        }
      });
    });
  }

  /**
   * @description checks if container is not dismissed, then remove hide
   * @method checkDismissed
   * @returns {void}
   */
  checkDismissed() {
    if (!this.isDismissed()) {
      this.container.classList.remove('fade-out');
      this.container.classList.remove('hide');
    }
  }

  /**
   * @description retrieves dismissed banner from session storage
   * @method isDismissed
   * @returns {boolean} banner dismissed
   */
  isDismissed() {
    return this.Store.getPersisted('hp-engagement-banner-dismissed', 'sessionStorage');
  }

  /**
   * @description toggles hide for dismissed banner
   * @method handleActiveToggle
   * @param {Event} e event object
   * @returns {void}
   */
  handleActiveToggle(e) {
    e.preventDefault();
    this.Store.persist('hp-engagement-banner-dismissed', true, 'sessionStorage');
    this.container.classList.add('fade-out');
    setTimeout(() => {
      this.container.classList.add('hide');
    }, 500);
  }

  /**
   * @description if top is > 250, fades out, otherwise removes hide and fade out
   * @method handleScroll
   * @returns {void}
   */
  handleScroll() {
    if (this.isDismissed()) return;
    const top = window.pageYOffset || document.documentElement.scrollTop;
    if (top > this.hideTopAt) {
      this.container.classList.add('fade-out');
    } else {
      this.container.classList.remove('hide');
      setTimeout(() => {
        this.container.classList.remove('fade-out');
      }, 0);
    }
  }

  /**
   * @description Load content
   * @method loadContent
   * @testExample loadContent({
   *   data: {
   *     META: { TEMPLATE: 'banner-icon-text-link', CONTAINER_TYPE: 'engagement-banner' },
   *     content: 'mocked content',
   *     icon: 'mocked icon',
   *   }
   * })
   * @testExpect performance.mark.called toEqual true
   * @testExpect performance.measure.called toEqual true
   * @testExpect console.log.called toEqual true
   * @testExpect cinemaHelper.register.called toEqual true
   * @testExpect this.bindFnClicks.called toEqual true
   * @testExpect window.fireImpressions.called toEqual true
   * @testExpect mockedElements[0].classList.contains('banner-icon-text-link') toEqual true
   * @testExpect mockedElements[0].innerHTML toInclude 'mocked content'
   * @testExpect mockedElements[0].innerHTML toInclude 'mocked icon'
   * @testExpect mockedContainerElement.classList.contains('loaded') toEqual true
   *
   * @mockElement .banner-partial-container
   * @mockElement a.close
   * @mockElement .engagement-content
   * @mockElement #engagement-default {}
   * @mockSpaParams { siteParams: { jsTimer: true } }
   * @mockVariable window fireImpressions () => {}
   * @spy performance.mark
   * @spy performance.measure
   * @spy console.log
   * @spy cinemaHelper.register
   * @spy this.bindFnClicks
   * @spy window.fireImpressions
   *
   * @param {Object} [event={ event: '' }] event to render
   * @returns {void}
   */
  loadContent(event = {
    event: ''
  }) {
    const eventData = event.data && event.data.META ? event.data : this.defaultContent;
    const data = Object.assign({}, {
      META: {
        TEMPLATE: defaultTemplate
      }
    }, eventData);
    if (spaParams.siteParams.jsTimer && performance.mark !== undefined) {
      try {
        performance.mark(`${this.adContainer}-loadContent-end`);
        performance.measure(`${this.adContainer}-loadContent`, `${this.adContainer}-loadContent-start`, `${this.adContainer}-loadContent-end`);
        const measures = performance.getEntriesByName(`${this.adContainer}-loadContent`);
        const measure = measures[0];
        console.log(`${this.adContainer} started loading content after ${measure.duration}ms`);
      } catch (e) {
        console.log(`${this.adContainer} started loading content at ${performance.now()}ms`);
      }
    }
    this.templateName = data.META.TEMPLATE;
    this.renderContent(event.data);
  }

  /**
   * @description Renders content to masthead
   * @method renderContent
   * @param {Object} data data to be rendered
   * @returns {void}
   */
  renderContent(data) {
    let template;
    let content;
    let isDefaultContent = true;
    // check returned META information
    if (data.META && data.META.CONTAINER_TYPE) {
      if (data.META.CONTAINER_TYPE.toLowerCase() === containerType) {
        content = data;
        isDefaultContent = false;
      } else {
        content = this.defaultContent;
        remoteConsole.error(`Targeting Error: Wrong container type: ${data.META.CONTAINER_TYPE}. "${containerType}" expected.`);
      }
    } else {
      content = this.defaultContent;
      remoteConsole.error('Targeting Error: missing Meta information');
    }
    if (content.blank) return;

    // remove classes that may have been accidentally added from target-preview module
    this.partialContainer.setAttribute('class', 'banner-partial-container');
    try {
      template = _moduleConfig.partials[this.templateName];
    } catch (e) {
      template = _moduleConfig.partials[defaultTemplate];
    }
    if (isDefaultContent) {
      this.partialContainer.setAttribute('data-default-content', this.adContainer);
    } else {
      this.partialContainer.setAttribute('data-ad-container', this.adContainer);
      if (content.clickToken) {
        this.partialContainer.setAttribute('data-ad-click-token', content.clickToken);
      }
    }
    this.partialContainer.innerHTML = template(_.defaultsDeep(content));
    this.partialContainer.classList.add(this.templateName);
    this.settings.target.classList.add('loaded');
    this.bindFnClicks();
    modalUtility.init(content);

    // Edgecase fallback because in-case 'loaded' class doesn't get added
    setTimeout(() => {
      this.settings.target.classList.add('loaded');
    }, 1000);
    if (content.animations) {
      animationUtility.init(this.partialContainer, content.animations);
    }
    if (typeof window.fireImpressions === 'function') {
      try {
        window.fireImpressions();
      } catch (e) {
        console.error(e);
      }
    }
  }

  /**
   * Method to detect the click event on the document and then filter out if the click has happened on the mobile hamburger icon: to close the marketing banner on the bottom
   * @param {*} event : mouse event
   * Returns: Nothing
   */
  detectHeaderHamburgerIconClick = event => {
    // target for hamburger icon: button and SVG
    const isHamburgerIcon = event.target.closest('.gt-nav-unauth-bofa-small--hamburger button');
    isHamburgerIcon && requestAnimationFrame(() => this.container.classList.add('hide'));
  };
}
registerModuleClass({
  moduleClass: engagementBannerModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { engagementBannerModuleJS as default, moduleConfig };
